import React from 'react';
import { IconProps } from '../IconProps';

export const HelpCircleIcon: React.FC<IconProps> = ({
	width = 21,
	height = 21,
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 21 21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		className={className}
	>
		<path
			d="M7.625 7.62469C7.62524 6.35338 8.57954 5.2847 9.84272 5.14115C11.1059 4.99761 12.2757 5.82492 12.5611 7.06376C12.8466 8.3026 12.1569 9.55842 10.9583 9.98219C10.4587 10.1588 10.1247 10.6314 10.125 11.1614V11.9997"
			stroke={stroke}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.125 14.5C9.95241 14.5 9.8125 14.6399 9.8125 14.8125C9.8125 14.9851 9.95241 15.125 10.125 15.125C10.2976 15.125 10.4375 14.9851 10.4375 14.8125C10.4375 14.6399 10.2976 14.5 10.125 14.5V14.5"
			stroke={stroke}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.125 19.5C15.3027 19.5 19.5 15.3027 19.5 10.125C19.5 4.94733 15.3027 0.75 10.125 0.75C4.94733 0.75 0.75 4.94733 0.75 10.125C0.75 15.3027 4.94733 19.5 10.125 19.5Z"
			stroke={stroke}
			strokeWidth="1.5"
		/>
	</svg>
);
